import React, {
  Fragment,
} from 'react';

// Components
import Helpers from '@Apis/helpers';
import RestrictedAccessMessage from '../../../../Common/RestrictedAccess/RestrictedAccessMessage';
import PRZButton from '../../../../Common/UI/PRZButton';
import PRZConfirmationPopover from '../../../../Common/UI/PRZConfirmationPopover';
import PRZInput from '../../../../Common/UI/PRZInput';
import PRZText from '../../../../Common/UI/PRZText';
import {
  actionType,
} from '../reducers';

const Footer = ({
  state, priceMasking, selectedAPInvoice, apiId, createAPInvoiceLoading, updateAPInvoiceLoading, dispatch, user, handleCreateAPInvoice,
}) => {
  const {
    formSubmitted,
    apInvoiceType,
    selectedCurrencyName,
    selectedCurrencyID,
    isAutomaticConversionRate,
    currencyConversionRate,
    cfAPInvoiceDoc,
    apInvoiceNumber,
    initialAPInvoiceNumber,
    docSeqId,
    selectedTenant,
    isAdhocAPInvoiceAllowed,
    tenantDepartmentId,
    selectedTenantSeller,
    apInvoiceTableData,
    visibleLineCfs,
    selectedSeller,
    selectedSellerId,
    gstNumber,
    invoiceNumber,
    apInvoiceDate,
    invoiceDate,
    freightSacCode,
    freightTaxInfo,
    cfAPInvoiceLine,
    isUserReadyOne,
    selectedGRNValue,
    discountType,
    selectedGRN,
    chargeData,
    ewayBillNumber,
    ewayBillList,
    selectedTags,
    vendorAddress,
    isLineWiseDiscount,
    discountPercentage,
    charge1Name,
    charge1Value,
    taxTypeName,
    taxTypeInfo,
    freightTaxId,
    freightTax,
    openFreightTax,
    freightTaxData,
    selectedAddressType,
    showAddressDrawer,
    terms,
    fileList,
    taxTypeId,
    updateDocumentReason,
    taxType,
    buttonClick,
    isUserReadyForUpdate,
    isUserReady,
  } = state;

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const restrictMessage = () => {
    const messages = []; // Collect restriction messages her

    if (isDataMaskingPolicyEnable && (isHideCostPrice || isHideSellingPrice)) {
      messages.push(
        `You don't have access to view/edit${isHideCostPrice ? ' cost price' : ''}${isHideCostPrice && isHideSellingPrice ? ' and' : ''}${isHideSellingPrice ? ' selling price' : ''}.`,
      );
    } else if (apInvoiceType === 'ADHOC' && isAdhocAPInvoiceAllowed) {
      messages.push(
        "You don't have access to create ADHOC AP Invoice in the selected business unit.",
      );
    }

    return messages; // Return collected messages or an empty array
  };
  return (
    <Fragment>
      <div className="form__footer">
        {!!restrictMessage()?.length && (
          <RestrictedAccessMessage
            message={restrictMessage()}
          />
        )}
        {(selectedAPInvoice && apiId) ? (
          <Fragment>
            {Helpers.getPermission(Helpers.permissionEntities.ACCOUNT_PAYABLE_INVOICE, Helpers.permissionTypes.CREATE, user) && (
              <PRZConfirmationPopover
                title="Are you sure you want to update?"
                content={(
                  <Fragment>
                    <PRZText text="Reason" required />
                    <PRZInput
                      placeholder="Enter update reason"
                      value={updateDocumentReason}
                      onChange={(e) => dispatch({ type: actionType.SET_MULTIPLE_FIELDS, payload: { updateDocumentReason: e.target.value } })}
                    />
                  </Fragment>
                )}
                onConfirm={() => {
                  if (!createAPInvoiceLoading || !updateAPInvoiceLoading) {
                    handleCreateAPInvoice(false, 'DRAFT');
                  }
                }}
                confirmButtonText="Confirm"
                cancelButtonText="Back"
                confirmDisabled={!updateDocumentReason}
              >
                <PRZButton
                  id="save-as-draft"
                  type="default"
                  wrapperStyle={{ marginRight: '10px' }}
                  buttonStyle={{
                    width: '130px',
                    height: '40px',
                    border: '1px solid #2d7df7',
                    color: '#2d7df7',
                  }}
                  isLoading={(createAPInvoiceLoading || updateAPInvoiceLoading) && buttonClick !== 'APPROVE'}
                  disabled={createAPInvoiceLoading || updateAPInvoiceLoading || isAdhocAPInvoiceAllowed}
                >
                  Save as Draft
                </PRZButton>
              </PRZConfirmationPopover>
            )}
            {Helpers.getPermission(Helpers.permissionEntities.ACCOUNT_PAYABLE_INVOICE, Helpers.permissionTypes.CREATE, user) && (
              <PRZConfirmationPopover
                title="Are you sure you want to update?"
                content={(
                  <Fragment>
                    <PRZText text="Reason" required />
                    <PRZInput
                      placeholder="Enter update reason"
                      value={updateDocumentReason}
                      onChange={(e) => dispatch({ type: actionType.SET_MULTIPLE_FIELDS, payload: { updateDocumentReason: e.target.value } })}
                    />
                  </Fragment>
                )}
                onConfirm={() => {
                  if (!createAPInvoiceLoading || !updateAPInvoiceLoading) {
                    handleCreateAPInvoice(true, 'ISSUED');
                  }
                }}
                confirmButtonText="Confirm"
                cancelButtonText="Back"
                confirmDisabled={!updateDocumentReason}
              >
                <PRZButton
                  id="save-and-issue"
                  isLoading={(createAPInvoiceLoading || updateAPInvoiceLoading) && buttonClick === 'APPROVE'}
                  disabled={createAPInvoiceLoading || updateAPInvoiceLoading || isAdhocAPInvoiceAllowed}
                  buttonStyle={{ width: '130px', height: '40px' }}
                >
                  Save and Issue
                </PRZButton>
              </PRZConfirmationPopover>
            )}
          </Fragment>
        ) : (
          <Fragment>
            {Helpers.getPermission(Helpers.permissionEntities.ACCOUNT_PAYABLE_INVOICE, Helpers.permissionTypes.CREATE, user) && (
              <PRZButton
                id="save-as-draft"
                type="default"
                onClick={() => {
                  if (!createAPInvoiceLoading || !updateAPInvoiceLoading) {
                    handleCreateAPInvoice(false, 'DRAFT');
                  }
                }}
                isLoading={(createAPInvoiceLoading || updateAPInvoiceLoading) && buttonClick !== 'APPROVE'}
                disabled={createAPInvoiceLoading || updateAPInvoiceLoading || isAdhocAPInvoiceAllowed}
                wrapperStyle={{ marginRight: '10px' }}
                buttonStyle={{
                  width: '130px',
                  height: '40px',
                  border: '1px solid #2d7df7',
                  color: '#2d7df7',
                }}
              >
                Save as Draft
              </PRZButton>
            )}
            {Helpers.getPermission(Helpers.permissionEntities.ACCOUNT_PAYABLE_INVOICE, Helpers.permissionTypes.CREATE, user) && (
              <PRZButton
                id="save-and-issue"
                onClick={() => {
                  if (!createAPInvoiceLoading || !updateAPInvoiceLoading) {
                    handleCreateAPInvoice(true, 'ISSUED');
                  }
                }}
                isLoading={(createAPInvoiceLoading || updateAPInvoiceLoading) && buttonClick === 'APPROVE'}
                disabled={createAPInvoiceLoading || updateAPInvoiceLoading || isAdhocAPInvoiceAllowed}
                buttonStyle={{ width: '130px', height: '40px' }}
              >
                Save and Issue
              </PRZButton>
            )}
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default Footer;
